import PropTypes from 'prop-types';
import InPlayContent from './inplay-content.js';
import MojitoCore from 'mojito/core';
import InPlayTypes from 'modules/inplay/types.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Module that displays InPlay events.
 *
 * @class InPlayContent
 * @name InPlayContent
 * @memberof Mojito.Modules.InPlay
 */

/**
 * `InPlayContent` prop types.
 *
 * @property {string} [selectedTab] - The code of the currently selected tab.
 * @property {Array<string>} [sportIds = []] - Array of the inplay sports ids.
 * @property {Array<string>} [favoriteEvents = []] - Array of favorite event ids.
 * @property {object} [eventGroups = {}] - Event groups of the inplay sports.
 *
 * @memberof Mojito.Modules.InPlay.InplayContent
 */
const propTypes = {
    eventGroups: PropTypes.object,
    selectedTab: PropTypes.string,
    sportIds: PropTypes.arrayOf(PropTypes.string),
    favoriteEvents: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
    sportIds: [],
    favoriteEvents: [],
    eventGroups: {},
    selectedTab: InPlayTypes.TABS.ALL_SPORTS_CODE,
};

export default UIView('InPlayContent', InPlayContent, propTypes, defaultProps);
